const getFilterData = state  => state.filterData;
const isFilterLoading = state  => state.isFilterLoading;

const getInventoryList = state  => state.inventoryList;
const isInventoryListLoading = state => state.isInventoryListLoading;

export default {
  getFilterData,
  isFilterLoading,
  getInventoryList,
  isInventoryListLoading
};



// WEBPACK FOOTER //
// ./src/store/modules/savings-plans/inventory/getters.js